interface CategoryTabsProps {
  categories: string[];
  active: string;
  onChange: (category: string) => void;
}

export default function CategoryTabs({ categories, active, onChange }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories.map((category) => {
        const isActive = category === active;
        return (
          <button
            key={category}
            type="button"
            onClick={() => onChange(category)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium font-label transition-colors cursor-pointer whitespace-nowrap ${
              isActive
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
            }`}
          >
            {category}
          </button>
        );
      })}
    </div>
  );
}